import React from "react";
import Modal from '../../component/Inc/Modal';
function PopLeave(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="com_input">
      <h2 className='pop_tit'>회원 탈퇴</h2>
      <div className="content_container scroll">
        <table className='com_board_list'>
          <tbody>
            <tr>
              <th>이름</th>
              <td>2023. 01. 12 <button className="name btn_link">홍요청103</button></td>
            </tr>
            <tr>
              <th>소속</th>
              <td>본사<span className="dot"/>고등부<span className="dot"/>파트</td>
            </tr>
            <tr>
              <th>생년월일</th>
              <td>1985.10.20(여)</td>
            </tr>
            <tr>
              <th>연락처</th>
              <td>010-2222-3333</td>
            </tr>
            <tr>
              <th>이메일</th>
              <td>test@naver.com</td>
            </tr>
            <tr>
              <th>담임</th>
              <td>김담임102</td>
            </tr>
            <tr>
              <th>입사일</th>
              <td>2022.03.03</td>
            </tr>
          </tbody>
        </table>
        <div className="com_input_wrap">
          <textarea className="textarea" placeholder="탈퇴 사유 입력"></textarea>
          <input type="text" className="input" placeholder="홍길동201" />
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn gray xs">취소</button>
        <button className="com_btn orange xs">회원탈퇴</button>
      </div>
    </Modal>
  );
}

export default PopLeave;